import { EndpointContract } from '../../architecture/ControllerContract';
import { z } from 'zod';
import { product } from '../Product';
import { objectId } from '../ObjectId';
import { pageInfo } from '../PageInfo';

const body = z
    .object({
        accountId: objectId,
        chatId: objectId.optional(),
        pageInfo
    })
    .strict();

const helpItem = z.intersection(
    z.object({
        id: z.string(),
        iconId: z.string(),
        title: z.string(),
        description: z.string(),
        tooltip: z.string()
    }),
    z.union([
        z.object({
            type: z.literal('sendMessage'),
            text: z.string()
        }),
        z.object({
            type: z.literal('writeMessage'),
            text: z.string()
        }),
        z.object({
            type: z.literal('uploadImage')
        })
    ])
);

const pageCustomization = z.object({
    /**
     * TODO: review, as it is currently unused in the client
     */
    helpItems: z.array(helpItem),
    initialGreeting: z.string()
});

const fetchAssistantConfigOutput = z
    .object({
        tenantId: objectId.optional(),
        pageCustomization,
        googleAnalyticsIds: z.array(z.string()).optional(),
        product: product.optional(),
        chatId: objectId,
        searchImageEnabled: z.boolean(),
        aspectRatio: z.union([
            z.literal('1'),
            z.literal('4/5'),
            z.literal('2/3')
        ]),
        discountBadge: z.enum(['hidden', 'text', 'percentage']),
        resources: z.record(z.string()),
        freeShippingPolicy: z
            .object({
                minimumAmount: z.number(),
                notificationThreshold: z.number()
            })
            .optional()
    })
    .strict();

export const fetchAssistantConfig = {
    verb: 'post',
    path: 'fetchAssistantConfig',
    schema: {
        body,
        response: {
            200: fetchAssistantConfigOutput
        }
    }
} as const satisfies EndpointContract;

export type FetchAssistantConfigOutput = z.infer<
    typeof fetchAssistantConfigOutput
>;

export type FetchAssistantConfigBody = z.infer<typeof body>;
